import * as constants from './constants';
import checkStatus from '../../utils/checkStatus';

export function updateCReportProps(payload) {
  return { type: constants.UPDATE_CREPORTS_PROP, payload };
}

export function submitReportSugg(payload, companyName) {
  return dispatch => {
    dispatch({ type: constants.SENDING_REPORT_SUGG });
    return fetch('/proxy/contracting/reportSugg', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ suggestion: payload, companyName }),
    })
    .then(checkStatus)
    .then(() => dispatch({ type: constants.SENT_REPORT_SUGG }))
    .catch(err => console.log('err in sending report suggestion', err));
  };
}

export function getAvailDocsForDiffReport({ collection, locationId, buyerId, email }) {
  return { type: 'GET_AVAIL_DOCS_FOR_DIFF_REPORTS', payload: { collection, locationId, buyerId, email } };
}

export function getDiffReport (docs) {
  return { type: constants.GET_CONTRACTING_DIFF_REPORT, payload: { docs } };
}

export function clearStore() {
  return { type: constants.CLEAR_STORE };
}


// WEBPACK FOOTER //
// ./src/app/stores/contracting-reports/actions.js